import script from "./StreamsWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamsWidget.vue?vue&type=script&setup=true&lang=js"

import "./StreamsWidget.vue?vue&type=style&index=0&id=78ed0544&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78ed0544"]])

export default __exports__